export const Common = {
  SHOW_PROGRESS: "SHOW_PROGRESS",
  CLOSE_PROGRESS: "CLOSE_PROGRESS",
  DOWNLOAD_PDF: "DOWNLOAD_PDF",
  SET_API_RESPONSE: "SET_API_RESPONSE",
};
